export const clearAuthStorage = () => {
  // S4: 'token' key is no longer used — normal sessions use httpOnly cookie.
  // Only clear the non-sensitive user profile key.
  localStorage.removeItem('user');
};

export const dispatchAuthLogout = () => {
  clearAuthStorage();
  window.dispatchEvent(new Event('authLogout'));
};

export const maybeRedirectToLogin = () => {
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};
